import {DeleteOutlined, EditOutlined, EyeOutlined, HomeOutlined, PlusOutlined, SyncOutlined, UserOutlined} from '@ant-design/icons';
import {Alert, Badge, Breadcrumb, Button, Dropdown, Form,  Input, Modal, Pagination, Popconfirm, Select, Space, Spin, Table, Tag, Tooltip, Upload, message,
} from 'antd';
import PropTypes from 'prop-types';
import  {useEffect, useRef, useState} from 'react';
import toast from 'react-hot-toast';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import {ReadMoreText} from '../../../commonComponents/ReadMoreText';
import SearchBar from '../../../commonComponents/SeachBar/SearchBar';
import {RQExcelUpload,
  RQGetBrandAPI, RQGetCategoryAPI, RQGetProductsByFilter, RQGetPromocodeAPI, RqAddProduct,
  RqDeleteProduct, RqGetAllProducts, RqGetProducts, RqUpdateProduct, RqUploadProductImage,
} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {NewProductScreen} from './NewProductScreen';
import {ProductDetailScreen} from './ProductDetailScreen';
import {ProductEditScreen} from './ProductEditScreen';

const Product = () => {
  const auth = useSelector(selectAuth);
  const location = useLocation();

  const token =auth?.tokenData;

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState(null);

  const [formTwo] = Form.useForm();

  const [dataSource, setDataSource] = useState([]);

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [productTypeFilter, setProductTypeFilter] = useState(null);

  const [minPrice, setMinPrice] = useState(null); 

  const [imageFiles, setImageFiles] = useState([]);

  const [previewUrls, setPreviewUrls] = useState([]);

  const [editModal, setEditModal] = useState({visible: false, record: null});

  const [viewModal, setViewModal] = useState({visible: false, record: null});

  const [filters, setFilters] = useState({});

  const [previewImagesModal, setPreviewImagesModal] = useState({
    visible: false,
    images: [],
  });
  const {Option} = Select;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [searchText, setSearchText] = useState('');

  const mapImagesToFileList = (images = []) =>
    images.map((url, index) => ({
      uid: `img-${index}`,
      name: url.split('/').pop(),
      status: 'done',
      url,
    }));
    
  useEffect(() => {
    if (
      location.state?.openEdit &&
    location.state?.productId &&
    dataSource.length > 0
    ) {
      const product = dataSource.find(
        p => p.id === location.state.productId,
      );

      if (product) {
        openEditModal(product);
      }
      navigate(location.pathname, {replace: true});
    }
  }, [dataSource]);

  useEffect(() => {
    setFilters(prev => {
      const updated = {...prev};
      if (minPrice !== undefined && minPrice !== null && minPrice !== '') {
        updated.minPrice = minPrice;
      } else {
        delete updated.minPrice;
      }
      return updated;
    });
  }, [minPrice]);

  useEffect(() => {
    setFilters(prev => {
      const updated = {...prev};

      if (productTypeFilter) {updated.productType = productTypeFilter;}
      else {delete updated.productType;}

      if (categoryFilter) {updated.category = categoryFilter;}
      else {delete updated.category;}

      if (brandFilter) {updated.brand = brandFilter;}
      else {delete updated.brand;}

      return updated;
    });
  }, [ productTypeFilter, categoryFilter, brandFilter]);

  const {
    data: filteredProductsData,
  } = RQGetProductsByFilter(filters);
  const {data: allProdutcs} = RqGetProducts();

  const data = dataSource;
  const pageSizeOptions = ['10', '20', '30', '50'];
  const paginatedData = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const navigate = useNavigate();

  const isEditing = record => record.key === editingKey;

  const handleCancel = () => {
    form.resetFields();        
    setImageFiles([]);         
    setPreviewUrls([]);       
    setIsModalVisible(false); 
  };

  const {data: userData, isLoading, error} = RqGetAllProducts();

  const {data:categories} = RQGetCategoryAPI(token);

  const {data:brands} = RQGetBrandAPI(token);

  const {data:promocode} = RQGetPromocodeAPI(token);

  const categoryOptions = categories
    ?.filter(c => c.isActive)
    .map(c => ({
      value: c.name,         
      label: c.name,
      features: c.features,   
    }));

  const brandOptions = brands?.filter(b => b.isActive).map(b => ({
    value: b.name,
    label: b.name,
  }));

  const promoCodeOptions = promocode?.filter(p => p.isActive).map(p => ({
    value: p.code, 
    label: p.code,
  }));
  const statusOptions = [
    {label: 'Active', value: 'ACTIVE'},
    {label: 'Inactive', value: 'INACTIVE'},
  ];

  const handleChange = value => {
    console.log(`selected ${value}`);
  };

  const handleFormSubmit = async values => {
    try {
      const eanCode = values.eanCode?.trim();
      if (!eanCode) {throw new Error('EAN code required');}

      const formattedVariants = [];

      for (const variant of values.variants) {
        const uploadedImages = [];

        for (const fileWrapper of variant.images) {
          const file = fileWrapper.originFileObj || null;
          if (file) {
            const url = await handleModalImageUpload(
              {file, onSuccess: () => {}, onError: () => {}},
              eanCode,
              variant.color,
              token,
            );
            if (url) {uploadedImages.push(url);}
          } else if (fileWrapper.url) {
            uploadedImages.push(fileWrapper.url); 
          }
        }

        if (!uploadedImages.length) {
          toast.error(`Please add at least one image for ${variant.color}`);
          return;
        }

        formattedVariants.push({
          color: variant.color,
          images: uploadedImages,
          sizes: variant.sizes.map(s => ({
            size: s.size,
            quantity: String(s.quantity),
            extraPrice: s.extraPrice || 0,
          })),
          status: 'ACTIVE',
        });
      }
    } catch (err) {
      console.error('Form submit error:', err);
      toast.error(err.message || 'Failed to submit product');
    }
  };

  const fileInputRef = useRef(null);
  async function uploadVariantImage({file, productId, color, token}) {
    try {
      const res = await fetch('/api/uploads/presigned', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          productId,
          variantColor: color,
          fileName: file.name,
          contentType: file.type,
        }),
      });

      if (!res.ok) {throw new Error('Failed to get presigned URL');}

      const {uploadUrl, fileUrl} = await res.json();
     
      const uploadRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {'Content-Type': file.type},
        body: file,
      });

      if (!uploadRes.ok) {throw new Error('Failed to upload image');}

      return fileUrl;
    } catch (err) {
      console.error('Upload Error:', err);
      message.error('Failed to upload image');
      return null;
    }
  }

  const handleModalImageUpload = async (
    {file, onSuccess, onError},
    productId,
    color,
    token,
  ) => {
    try {
      const url = await uploadVariantImage({file, productId, color, token});
      if (!url) {throw new Error('Upload failed');}

      onSuccess({url});
      return url;
    } catch (err) {
      onError(err);
    }
  };

  const updateProductMutation = RqUpdateProduct({
    onSuccess: () => {
      toast.success('Product updated successfully');
      setEditModal({visible: false, record: null});
    },
    onError: err => {
      toast.error(err.message || 'Product update failed');
    },
  });

  const handleUpdateSubmit = async () => {
    try {
      const values = await form.validateFields();

      const formattedVariants = [];

      for (const variant of values.variants) {
        const uploadedImages = [];

        for (const fileWrapper of variant.images) {
          const file = fileWrapper.originFileObj || null;

          if (file) {
            const url = await handleModalImageUpload(
              {file, onSuccess: () => {}, onError: () => {}},
              values.eanCode,
              variant.color,
              token,
            );
            if (url) {uploadedImages.push(url);}
          } else if (fileWrapper.url) {
            uploadedImages.push(fileWrapper.url);
          }
        }

        if (!uploadedImages.length) {
          message.error(`Please add at least one image for ${variant.color}`);
          return;
        }

        formattedVariants.push({
          ...variant,
          images: uploadedImages,
        });
      }

      const productData = {
        ...values,
        imageUrl: formattedVariants[0]?.images || [],
        promoCode: values.promoCode ?? null,

        // THIS is what actually updates DB relation
        promocodeInfo: values.promoCode
          ? {code: values.promoCode}
          : null,

        variants: formattedVariants,
      };
      
      updateProductMutation.mutate({
        token,
        id: editModal.record.id,
        productData,
      });

    } catch (err) {
      console.error('Edit submit failed:', err);
      message.error('Failed to update product');
    }
  };

  useEffect(() => {
    const hasFilters =
  (filters?.minPrice && filters?.minPrice !== '') ||
  (filters?.category && filters?.category !== '') ||
  (filters?.brand && filters?.brand !== '') ||
  (filters?.productType && filters?.productType !== '') ||
  (filters?.productName && filters?.productName !== '') ||
  (filters?.features && filters.features.length > 0);

    const source = hasFilters
      ? filteredProductsData
      : allProdutcs;

    if (!source) {return;}

    const formattedData = source
      .filter(product => {
        // Status filter
        if (!(product.status === 'ACTIVE' || product.status === 'INACTIVE')) {
          return false;
        }

        if (filters.features?.length) {
          const productFeatures = product.features || [];

          const hasAtLeastOneFeature = filters.features.some(feature =>
            productFeatures.includes(feature),
          );

          if (!hasAtLeastOneFeature) {
            return false;
          }
        }

        return true;
      })
      .map((product, index) => ({
        key: product.id,
        index: index + 1,
        id: product.id,
        productName: product.productName,
        description: product.description,
        price: product.price,
        category: product.category,
        features: product.features || [],
        discount: product.discount,
        brand: product.brand,
        promoCode: product.promoCode || null,
        imageUrl:
      product.variants?.[0]?.images?.length > 0
        ? product.variants[0].images
        : [],
        variants: product.variants || [],
        eanCode: product.eanCode || product.barcode || '',
        status: product.status,
      }));

    setDataSource(formattedData);

  }, [filters, filteredProductsData, allProdutcs]);

  const openEditModal = record => {
    setEditModal({visible: true, record});
    setImageFiles(mapImagesToFileList(record.variants?.[0]?.images || []));

    formTwo.setFieldsValue({
      ...record,
      promoCode: record.promoCode ?? (record.promocodeInfo?.code || null),
      imageUrl: mapImagesToFileList(record.imageUrl || []),
      variants: (record.variants || []).map(v => ({
        ...v,
        images: mapImagesToFileList(v.images || []),
      })),
    });
  }; 

  //DELETE FUNCTIONALITY 
  const deleteProductMutation = RqDeleteProduct({
    onSuccess: () => {
      toast.success('Product deleted successfully');
      handleCancel(); 
    },
    onError: err => {
      toast.error(err.message || 'Failed to delete product');
    },
  });

  const handleDelete = async id => {
    try {
      await deleteProductMutation.mutateAsync({token, id});
    } catch (err) {
   
      console.error(err);
    }
  };
  //dropbox
  const toDropboxRawUrl = (url = '') =>
    url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
      .replace('?dl=0', '');

  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: 'Image',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (urls = [], record) => {
        if (!urls.length) {
          return <span style={{color: '#999'}}>No Image</span>;
        }

        return (
          <>
            <button
              onClick={() =>
                setPreviewImagesModal({
                  visible: true,
                  recordKey: record.key,
                  images: urls,
                })
              }
              style={{
                cursor: 'pointer',
                width: 64,
                height: 64,
                position: 'relative',
                border: 'none',
                padding: 0,
                background: 'transparent',
              }}
              aria-label={'View product images'}
              type={'button'}
            >
              <Badge count={urls.length} offset={[-5, 5]}>
                <img
                  src={toDropboxRawUrl(urls[0])}
                  alt={'Product-0'}
                  className={'w-full h-44 md:h-80 object-cover rounded-lg'}
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: 6,
                  }}
                />
              </Badge>
            </button>

            <Modal
              title={'Product Images'}
              open={
                previewImagesModal.visible &&
            previewImagesModal.recordKey === record.key
              }
              footer={null}
              onCancel={() =>
                setPreviewImagesModal({
                  visible: false,
                  recordKey: null,
                  images: [],
                })
              }
            >
              <div style={{display: 'flex', gap: 12, flexWrap: 'wrap'}}>
                {urls.map((url, idx) => (
                  <img
                    key={idx}
                    src={toDropboxRawUrl(urls[idx])}
                    alt={`Product-${idx}`}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: 6,
                    }}
                  />
                ))}
              </div>
            </Modal>
          </>
        );
      },
    },

    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status, record) => (
       
        <Tag
          color={status === 'ACTIVE' ? 'green' : 'red'}
          style={{cursor: 'pointer'}}
        >
          {status || 'INACTIVE'}
        </Tag>
      ),
    },

    {
      title: 'EAN Code',
      dataIndex: 'eanCode',
      key: 'eanCode',
      width: 200,
      render: (_, record) => {
        return record.eanCode;
      },
    },
    {
      title: 'Name',
      dataIndex: 'productName',
      key: 'productName',
      width: 200,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'productName'} style={{margin: 0}}>
            <Input className={'whitespace-normal break-words max-w-xs'} />
          </Form.Item>
        ) : (
          <div className={'whitespace-normal break-words max-w-xs'}>{record.productName}</div>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 400,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'description'} style={{margin: 0}}>
            <Input.TextArea rows={3} />
          </Form.Item>
        ) : (
          <ReadMoreText text={record.description} maxLength={150} />
        );
      },
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      render: category => category || '-',
      
    },
    {
      title: 'Features',
      dataIndex: 'features',
      key: 'features',
      render: features => features?.length ? features.join(', ') : '-',
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand',
      render: brand => brand || '-',
    },
    {
      title: 'PromoCode',
      dataIndex: 'promoCode', 
      key: 'promoCode',
      render: promoCode => promoCode || '-', 
    },
    {
      title: 'Discount',
      dataIndex: 'discount',
      key: 'discount',
      render: discount =>
        discount > 0 ? <Tag color={'green'}>{discount}%</Tag> : <Tag color={'default'}>No Discount</Tag>,
    },
    {
      title: 'Variants',
      dataIndex: 'variants',
      key: 'variants',
      render: variants =>
        variants?.length ? (
          <Space direction={'vertical'} size={'small'}>
            {variants.map((v, idx) => (
              <div key={idx} style={{border: '1px solid #eee', padding: 6, borderRadius: 4}}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4}}>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      background: v.color.toLowerCase(),
                    }}
                  />
                  <b>{v.color}</b>
                </div>
                <div>
                  {v.sizes?.map((s, sIdx) => (
                    <Tag key={sIdx} color={s.quantity <= 5 ? 'red' : 'blue'} style={{marginBottom: 2}}>
                    Size: {s.size}, Qty: {s.quantity}
                      {s.extraPrice ? `, +₹${s.extraPrice}` : ''}
                    </Tag>
                  ))}
                </div>
              </div>
            ))}
          </Space>
        ) : '-',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item name={'price'} style={{margin: 0}}>
            <Input />
          </Form.Item>
        ) : (
          record.price
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Tooltip title={'Edit'}>
            <Button
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
            />
          </Tooltip>

          <Tooltip title={'View'}>
            <Button
              icon={<EyeOutlined />}
              onClick={() => setViewModal({visible: true, record})}
            />
          </Tooltip>

          <Tooltip title={'Delete'}>
            <Popconfirm
              title={'Are you sure you want to delete this item?'}
              onConfirm={() => handleDelete(record.id)}
              okText={'Yes'}
              cancelText={'No'}
            >
              <Button danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const {mutate: uploadExcel} = RQExcelUpload({
    onSuccess: () => {
      toast.success('Products imported successfully');
      handleCancel(); 
    },
    onError: error => {
      toast.error(error?.message || 'Failed to import Excel');
    },
  });

  const handleExcelUpload = e => {
    const file = e.target.files[0];
    if (!file) {return;}

    const formData = new FormData();
    formData.append('file', file);

    uploadExcel({token, formData});
  };
  const handleSearch = (value = '') => {
    const cleanedText = value.trim().toLowerCase();

    setSearchText(value); // ✅ store input

    setFilters(prev => {
      const updated = {...prev};

      if (cleanedText) {updated.productName = cleanedText;}
      else {delete updated.productName;}

      return updated;
    });
  };

  if (!token) {
    message.error('Token missing. Please login again.');
    return;
  }

  if (isLoading) {
    return(
      <div className={'flex justify-center items-center'}>
        <Spin size={'large'} />
      </div>
    );}

  if (error) {
    return <Alert message={'Failed to load users'} type={'error'} />;
  }

  return(
    <div>
      <Breadcrumb className={'md:flex hidden mb-6'}
        items={[
          {
            href: '/dashboard',
            title: <HomeOutlined />,
          },
          {
            href: '/product',
            title: (
              <>
                <UserOutlined />
                <span>product</span>
              </>
            ),
          },
        ]}
      />
      <div className={'flex lg:flex-row flex-col justify-between'}>
        <div className={'flex lg:flex-row flex-col gap-2  items-start mb-4 w-2/3 '}>  
          <SearchBar
            value={searchText}   
            onSearch={handleSearch}
            placeholder={'Search products...'}
          />
          <Select
            placeholder={'Filter by category'}
            allowClear
            showSearch
            value={categoryFilter || undefined}
            onChange={value => setCategoryFilter(value)}
            options={categoryOptions}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{width: 220}}
          />

          <Select
            placeholder={'Filter by brand'}
            allowClear
            showSearch
            value={brandFilter || undefined}
            onChange={value => setBrandFilter(value)}
            options={brandOptions}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{width: 220}}
          />
          <Button
            icon={<SyncOutlined />}
            onClick={() => {
              setCategoryFilter(null);
              setBrandFilter(null);
              setProductTypeFilter(null);
              setMinPrice(null);
              setFilters({});
              setSearchText(''); 
            }}
          >
  Reset Filters
          </Button>
        </div>

        {/* Add New Product */}
        <div className={'flex gap-4 md:justify-end justify-center mb-4'}>
          <Button
            type={'primary'}
            icon={<PlusOutlined />}
            onClick={() => setIsModalVisible(true)}
            className={'w-36'}
          >
          Add New Product
          </Button>

          {/* Upload Excel */}
          <label>
            
            <Button
              type={'primary'}
              icon={<PlusOutlined />}
              className={'bg-primary-900  text-white'}
              onClick={() => {
                console.log('UPLOAD BUTTON CLICKED');
                fileInputRef.current.click(); 
              }}
            >
  Upload Excel
            </Button>

            <input
              ref={fileInputRef}                 
              type={'file'}
              accept={'.xlsx,.xls'}
              hidden
              onChange={handleExcelUpload}       
            />
          </label>
        </div>
      </div>

      <div className={'flex justify-center items-center mt-2 w-full'}>
        <div className={'md:w-full lg:max-w-full overflow-x-auto'}>
          <Form form={formTwo} component={false}>
            <Table
              tableLayout={'fixed'}
              size={'middle'}
              scroll={{x: 'max-content'}}
              columns={columns}
              dataSource={paginatedData}
              rowKey={'id'}
              pagination={false}
            />
           
            {/* pagination */}
            <div className={'flex justify-between items-center mt-4 px-2'}>
              
              <Select
                value={String(pageSize)}
                onChange={value => {
                  setPageSize(Number(value));
                  setCurrentPage(1);
                }}
                style={{width: 120}}
              >
                {pageSizeOptions.map(size => (
                  <Option key={size} value={size}>
                    {size} / page
                  </Option>
                ))}
              </Select>

              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={data.length}
                showSizeChanger={false}
                onChange={page => setCurrentPage(page)}
              />
            </div>
            <NewProductScreen   isModalVisible={isModalVisible}
              handleModalImageUpload={handleModalImageUpload}
              setPreviewUrls={setPreviewUrls}
              // addProductMutation={addProductMutation}
              setEditModal={setEditModal}
              categoryOptions={categoryOptions}
              brandOptions={brandOptions}
              promoCodeOptions={promoCodeOptions}
              statusOptions={statusOptions}
              form={form}
              previewUrls={previewUrls}
              updateProductMutation={updateProductMutation}
              token={token}
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              dataSource={paginatedData}
              setDataSource={setDataSource}
              handleChange={handleChange}
              handleCancel={handleCancel}
              handleFormSubmit={handleFormSubmit}
            />
            <ProductEditScreen editModal={editModal}
              setEditModal={setEditModal}
              form={formTwo}
              categoryOptions={categoryOptions}
              brandOptions={brandOptions}
              promoCodeOptions={promoCodeOptions}
              statusOptions={statusOptions}
              updateProductMutation={updateProductMutation}
              token={token}
              imageFiles={imageFiles}
              setImageFiles={setImageFiles}
              dataSource={dataSource}
              setDataSource={setDataSource}
              handleChange={handleChange}
              handleModalImageUpload={handleModalImageUpload}
              handleUpdateSubmit={handleUpdateSubmit}
              productData={selectedProduct}
            />
            <ProductDetailScreen viewModal={viewModal} setViewModal={setViewModal} />
          </Form>
        </div>
      </div>
    </div>
  );
};

Product.propTypes = {
  'data-row-key': PropTypes.string,
  style: PropTypes.object,

};

export default Product;
